import { userAgentParser } from '@common/UserAgentParser/UserAgentParser'

/**
 * Edge böngészőt használja a user.
 * @param ua - UserAgent.
 */
export default function isEdge (ua: string): boolean {
  return userAgentParser.isEdge(ua)
}
